// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.common-search-bar {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.common-search-bar.dark {
  background-color: var(--dark-blue) !important;
}

.dark .common-search-input {
  background-color: #1e293b;
  border-color: #334155;
  color: #e2e8f0;
}

.dark .common-search-input::placeholder {
  color: #64748b;
}

.dark .common-search-input:focus {
  border-color: #3b82f6;
}

.common-search-input {
  width: 100%;
  border: 1.5px solid #e5e7eb;
  background-color: #ffffff;
  border-radius: 999px;
  padding: 12px 8px 12px 34px;
  outline: none;
  transition: border-color 0.15s;
}

.common-search-input:focus {
  border-color: #0860e6;
}

.common-search-bar > *:first-child {
  position: absolute;
  top: 50%;
  left: 0.5rem;
  transform: translateY(-50%);
  pointer-events: none;
}

/* .common-search-bar > *:last-child {
  position: absolute;
  top: 50%;
  right: 0.5rem;
  transform: translateY(-50%);
} */
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/posnavbar/components/commonSearchbar/commonSearchbar.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,yBAAyB;EACzB,oBAAoB;EACpB,2BAA2B;EAC3B,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;;;;;GAKG","sourcesContent":[".common-search-bar {\n  position: relative;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.common-search-bar.dark {\n  background-color: var(--dark-blue) !important;\n}\n\n.dark .common-search-input {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n\n.dark .common-search-input::placeholder {\n  color: #64748b;\n}\n\n.dark .common-search-input:focus {\n  border-color: #3b82f6;\n}\n\n.common-search-input {\n  width: 100%;\n  border: 1.5px solid #e5e7eb;\n  background-color: #ffffff;\n  border-radius: 999px;\n  padding: 12px 8px 12px 34px;\n  outline: none;\n  transition: border-color 0.15s;\n}\n\n.common-search-input:focus {\n  border-color: #0860e6;\n}\n\n.common-search-bar > *:first-child {\n  position: absolute;\n  top: 50%;\n  left: 0.5rem;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n\n/* .common-search-bar > *:last-child {\n  position: absolute;\n  top: 50%;\n  right: 0.5rem;\n  transform: translateY(-50%);\n} */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
